export const name = 'gzColorPicker';
export default function gzColorPicker(
  // Directive angular dependencies
) {
  'ngInject';

  let directive = {
    restrict: 'EA',
    require: '^ngModel',
    scope: {
      gzNative: '@?',
      color: '=',
      options: '='
    },
    template: require('./color-picker.jade'),
    link: colorPickerLink,
    controller: colorPickerController,
    controllerAs: 'vm',
    bindToController: true,
  };
  return directive;

  //////////////////////

  function colorPickerLink(scope, element, attrs, ngModelCtrl) {
    scope.vm.setModelValue = () => {
      ngModelCtrl.$setViewValue(scope.vm.color);
    };

    scope.vm.focusInput = () => {
      scope.$applyAsync(() => {
        let input = element[0].querySelector('.manual-input input');
        if (input) {
          input.focus();
          input.select();
        }
      });
    };
  }

  /** @ngInject */
  function colorPickerController(
    $window
  ) {
    // Constants
    const DEFAULT_COLOR = '#0e8a16';

    // Variables
    // View Model
    let vm = this;
    vm.colorOptions = [
      '#b60205',
      '#d93f0b',
      '#fbca04',
      '#0e8a16',
      '#006b75',
      '#1d76db',
      '#0052cc',
      '#5319e7',
      '#e99695',
      '#f9d0c4',
      '#fef2c0',
      '#c2e0c6',
      '#bfdadc',
      '#c5def5',
      '#bfd4f2',
      '#d4c5f9',
    ];

    vm.colorChanged = colorChanged;
    vm.randomize = randomize;
    vm.isDarkContrast = isDarkContrast;
    vm.closeOnEnterOrEsc = closeOnEnterOrEsc;
    vm.preventEnterOrEsc = preventEnterOrEsc;

    vm.$onInit = onInit;
    return;

    ///////////////////////////////////////////////////////////
    // Activate
    function onInit() {
      if (!vm.color) {
        vm.color = DEFAULT_COLOR;
      }
    }

    function randomize(){
      // Adapted from http://disq.us/p/di2t9p
      vm.color = '#'+ ('000000' + ($window.Math.floor($window.Math.random()*0xFFFFFF)).toString(16)).slice(-6);
      if (_.get(vm.cycleOptions, 'api')) {
        vm.options.api.changeColor(vm.color);
      }
    }

    function colorChanged(color) {
      vm.color = color;
      if (_.get(vm.cycleOptions, 'api')) {
        vm.options.api.changeColor(vm.color);
      }
      vm.show = false;
    }

    // Adapted from https://24ways.org/2010/calculating-color-contrast/
    function isDarkContrast(hexcolor) {
      if (!hexcolor) {
        return true;
      }

      let r = $window.parseInt(hexcolor.substr(1, 2),16);
      let g = $window.parseInt(hexcolor.substr(3, 2), 16);
      let b = $window.parseInt(hexcolor.substr(5, 2), 16);
      let yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
      return yiq >= 128;
    }

    function closeOnEnterOrEsc($event) {
      $event.stopPropagation();
      $event.preventDefault();
      if ($event.key === 'Enter' || $event.key === 'Escape') {
        colorChanged(vm.color);
      }
    }

    // Necessary to capture on keydown to prevent actions like submit from occuring
    function preventEnterOrEsc($event) {
      if ($event.key === 'Enter' || $event.key === 'Escape') {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }

}
